(function () {
  function decodeBase64Unicode(input) {
    const binary = window.atob(input);

    if (window.TextDecoder) {
      const bytes = new Uint8Array(binary.length);

      for (let i = 0; i < binary.length; i += 1) {
        bytes[i] = binary.charCodeAt(i);
      }

      return new TextDecoder('utf-8').decode(bytes);
    }

    return decodeURIComponent(escape(binary));
  }

  function escapeHtml(value) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;',
    };

    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return map[char];
    });
  }

  function safeHandle(value, fallback) {
    const handle = String(value || fallback || 'item')
      .toLowerCase()
      .replace(/[^a-z0-9_-]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

    return handle || 'item';
  }

  function normalizePath(url) {
    if (!url || url === '#') return '';

    try {
      const parsedUrl = new URL(url, window.location.origin);
      let path = parsedUrl.pathname || '/';

      if (path.length > 1) {
        path = path.replace(/\/$/, '');
      }

      return path;
    } catch (error) {
      return '';
    }
  }

  function isCurrentUrl(url) {
    const itemPath = normalizePath(url);
    if (!itemPath) return false;

    let currentPath = window.location.pathname || '/';

    if (currentPath.length > 1) {
      currentPath = currentPath.replace(/\/$/, '');
    }

    return itemPath === currentPath;
  }

  function hasActiveChild(item) {
    if (isCurrentUrl(item.url)) return true;

    const children = Array.isArray(item.children) ? item.children : [];

    return children.some(function (child) {
      return hasActiveChild(child);
    });
  }

  function getIconHtml(selector, fallback) {
    const icon = document.querySelector(selector);
    return icon ? icon.innerHTML : fallback;
  }

  function bindDawnDrawerEvents(menuList) {
    const drawer = document.querySelector('header-drawer');

    if (!drawer) return;

    if (typeof drawer.onSummaryClick === 'function') {
      menuList.querySelectorAll('summary').forEach(function (summary) {
        summary.addEventListener('click', drawer.onSummaryClick.bind(drawer));
      });
    }

    if (typeof drawer.onCloseButtonClick === 'function') {
      menuList.querySelectorAll('button.menu-drawer__close-button').forEach(function (button) {
        button.addEventListener('click', drawer.onCloseButtonClick.bind(drawer));
      });
    } else {
      menuList.querySelectorAll('button.menu-drawer__close-button').forEach(function (button) {
        button.addEventListener('click', function (event) {
          const details = event.currentTarget.closest('details');
          if (details) details.removeAttribute('open');
        });
      });
    }
  }

  function buildMobileMenu() {
    const dataEl = document.getElementById('HeaderMenuDataEncoded');
    const menuList = document.querySelector('[data-mobile-menu-list]');

    if (!dataEl || !menuList || menuList.dataset.built === 'true') return;

    const arrowIcon = getIconHtml('[data-mobile-menu-arrow-icon]', '‹');
    const caretIcon = getIconHtml('[data-mobile-menu-caret-icon]', '›');

    function icon(html) {
      return '<span class="svg-wrapper">' + html + '</span>';
    }

    function renderGrandchildItem(grandchild, parentHandle, childHandle, index) {
      const grandchildHandle = safeHandle(grandchild.handle, 'grandchild-' + index);
      const activeClass = isCurrentUrl(grandchild.url) ? ' menu-drawer__menu-item--active' : '';
      const activeAttr = isCurrentUrl(grandchild.url) ? ' aria-current="page"' : '';

      return (
        '<li>' +
          '<a ' +
            'id="HeaderDrawer-' + escapeHtml(parentHandle) + '-' + escapeHtml(childHandle) + '-' + escapeHtml(grandchildHandle) + '" ' +
            'href="' + escapeHtml(grandchild.url || '#') + '" ' +
            'class="menu-drawer__menu-item link link--text list-menu__item focus-inset' + activeClass + '"' +
            activeAttr +
          '>' +
            escapeHtml(grandchild.title) +
          '</a>' +
        '</li>'
      );
    }

    function renderChildItem(child, parentHandle, index) {
      const childHandle = safeHandle(child.handle, 'child-' + index);
      const grandchildren = Array.isArray(child.children) ? child.children : [];

      if (!grandchildren.length) {
        const activeClass = isCurrentUrl(child.url) ? ' menu-drawer__menu-item--active' : '';
        const activeAttr = isCurrentUrl(child.url) ? ' aria-current="page"' : '';

        return (
          '<li>' +
            '<a ' +
              'id="HeaderDrawer-' + escapeHtml(parentHandle) + '-' + escapeHtml(childHandle) + '" ' +
              'href="' + escapeHtml(child.url || '#') + '" ' +
              'class="menu-drawer__menu-item link link--text list-menu__item focus-inset' + activeClass + '"' +
              activeAttr +
            '>' +
              escapeHtml(child.title) +
            '</a>' +
          '</li>'
        );
      }

      const childActiveClass = hasActiveChild(child) ? ' menu-drawer__menu-item--active' : '';

      return (
        '<li>' +
          '<details id="Details-menu-drawer-' + escapeHtml(parentHandle) + '-' + escapeHtml(childHandle) + '">' +
            '<summary ' +
              'id="HeaderDrawer-' + escapeHtml(parentHandle) + '-' + escapeHtml(childHandle) + '" ' +
              'class="menu-drawer__menu-item link link--text list-menu__item focus-inset' + childActiveClass + '"' +
            '>' +
              escapeHtml(child.title) +
              icon(arrowIcon) +
              icon(caretIcon) +
            '</summary>' +
            '<div ' +
              'id="childlink-' + escapeHtml(childHandle) + '" ' +
              'class="menu-drawer__submenu has-submenu gradient motion-reduce"' +
            '>' +
              '<button class="menu-drawer__close-button link link--text focus-inset" aria-expanded="true">' +
                icon(arrowIcon) +
                escapeHtml(child.title) +
              '</button>' +
              '<ul class="menu-drawer__menu list-menu" role="list" tabindex="-1">' +
                grandchildren.map(function (grandchild, grandchildIndex) {
                  return renderGrandchildItem(grandchild, parentHandle, childHandle, grandchildIndex);
                }).join('') +
              '</ul>' +
            '</div>' +
          '</details>' +
        '</li>'
      );
    }

    function renderTopItem(item, index) {
      const itemHandle = safeHandle(item.handle, 'item-' + index);
      const children = Array.isArray(item.children) ? item.children : [];

      if (!children.length) {
        const activeClass = isCurrentUrl(item.url) ? ' menu-drawer__menu-item--active' : '';
        const activeAttr = isCurrentUrl(item.url) ? ' aria-current="page"' : '';

        return (
          '<li>' +
            '<a ' +
              'id="HeaderDrawer-' + escapeHtml(itemHandle) + '" ' +
              'href="' + escapeHtml(item.url || '#') + '" ' +
              'class="menu-drawer__menu-item list-menu__item link link--text focus-inset' + activeClass + '"' +
              activeAttr +
            '>' +
              escapeHtml(item.title) +
            '</a>' +
          '</li>'
        );
      }

      const activeClass = hasActiveChild(item) ? ' menu-drawer__menu-item--active' : '';

      return (
        '<li>' +
          '<details id="Details-menu-drawer-menu-item-' + (index + 1) + '">' +
            '<summary ' +
              'id="HeaderDrawer-' + escapeHtml(itemHandle) + '" ' +
              'class="menu-drawer__menu-item list-menu__item link link--text focus-inset' + activeClass + '"' +
            '>' +
              escapeHtml(item.title) +
              icon(arrowIcon) +
              icon(caretIcon) +
            '</summary>' +
            '<div ' +
              'id="link-' + escapeHtml(itemHandle) + '" ' +
              'class="menu-drawer__submenu has-submenu gradient motion-reduce" ' +
              'tabindex="-1"' +
            '>' +
              '<div class="menu-drawer__inner-submenu">' +
                '<button class="menu-drawer__close-button link link--text focus-inset" aria-expanded="true">' +
                  icon(arrowIcon) +
                  escapeHtml(item.title) +
                '</button>' +
                '<ul class="menu-drawer__menu list-menu" role="list" tabindex="-1">' +
                  children.map(function (child, childIndex) {
                    return renderChildItem(child, itemHandle, childIndex);
                  }).join('') +
                '</ul>' +
              '</div>' +
            '</div>' +
          '</details>' +
        '</li>'
      );
    }

    try {
      const encoded = dataEl.textContent.trim();
      const decoded = decodeBase64Unicode(encoded);
      const menuData = JSON.parse(decoded);

      menuList.innerHTML = menuData.map(function (item, index) {
        return renderTopItem(item, index);
      }).join('');

      bindDawnDrawerEvents(menuList);

      menuList.dataset.built = 'true';
    } catch (error) {
      console.warn('Mobile menu render failed:', error);
    }
  }

  function initMobileMenuRender() {
    const drawerTrigger = document.querySelector('#Details-menu-drawer-container > summary');

    if (!drawerTrigger) return;

    drawerTrigger.addEventListener('pointerdown', buildMobileMenu, { once: true });
    drawerTrigger.addEventListener('touchstart', buildMobileMenu, { once: true });
    drawerTrigger.addEventListener('mouseover', buildMobileMenu, { once: true });
    drawerTrigger.addEventListener('focus', buildMobileMenu, { once: true });

    drawerTrigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        buildMobileMenu();
      }
    }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenuRender);
  } else {
    initMobileMenuRender();
  }
})();